import i18n from '../utils/i18n';

export const REGULATION_TYPE: { 1: string; 2: string; 3: string } = {
  1: i18n.t('common.specification'),
  2: i18n.t('common.company-agreement'),
  3: i18n.t('common.implementation'),
};